import { render, staticRenderFns } from "./MortgageLeadFormWrapper.vue?vue&type=template&id=9a72ace8&"
import script from "./MortgageLeadFormWrapper.vue?vue&type=script&lang=ts&"
export * from "./MortgageLeadFormWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports